import React from "react";
import { useEffect, useState } from "react";
import {
  NuDatePicker,
  NuInputNumber,
  NuInputText,
  NuLabel,
  NuSelect,
  NuTextArea,
} from "../../../../Components/Utils/NuInput";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../Services/axiosCommon";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import BreadCrumb from "../../../../Components/Utils/Breadcrumbs";
import Dasboard from "../../../../Components/Icons/Dasboard";
import NuDate from "../../../../Components/Utils/NuDate";
import * as yup from "yup";
import { notification } from "antd";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";

export default function EditInvoiceOut() {
  const { value: Status } = useFetchMataData(`/Metadata/noteStatus`);
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data;
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [projectList, setProjectList] = useState([]);

  const [createNew, setCreateNew] = useState({
    projectId: "",
    invoice_no:"",
    type:"outgoing",
    date: "",
    submittedOn: "",
    amount: "",
    receivedAmount: "",
    status: "",
    description: "",
    comments: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema: yup.object({
    //   title: yup.string().required("Title is Required"),
    //   status: yup.string().required("Please Select Status"),
    }),
    onSubmit: async (value) => {
      setIsLoading(true);

      data
        ? axios
            .put(`/payments/${data?.paymentId}`, value)
            .then((res) => {
              if (res.data.status == true) {
                setIsLoading(false);
                api.success({
                  message: `Add successfully`,
                  description: res?.data?.msg || " created",
                  placement: "bottomRight",
                });
                navigate(-1);
              } else {
                setIsLoading(false);
                api.error({
                  message: `Unsuccessfully`,
                  description: res?.data?.msg || "creation failed",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              api.error({
                message: `Unsuccessfully`,
                description: err?.response?.data?.msg || "creation failed",
                placement: "bottomRight",
              });
            })
        : axios
            .post("/payments/", value)
            .then((res) => {
              if (res.data.status == true) {
                setIsLoading(false);
                api.success({
                  message: `Add successfully`,
                  description: res?.data?.msg || " created",
                  placement: "bottomRight",
                });
                navigate(-1);
              } else {
                setIsLoading(false);
                api.error({
                  message: `Unsuccessfully`,
                  description: res?.data?.msg || "creation failed",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              api.error({
                message: `Unsuccessfully`,
                description: err?.response?.data?.msg || "creation failed",
                placement: "bottomRight",
              });
            });
    },
  });

  async function getProject() {
    await axios
      .get(`/Team/getUserProjectId`)
      .then(async (res) => {
        let list = res?.data?.data || [];
        let finalData = [];
        (await res?.data?.data) &&
          list.map((item, idx) => {
            finalData.push({
              value: item.ProjectId,
              label: item.ProjectName,
            });
          });
        setProjectList(finalData);

        // await res?.data?.Project && setTotalProject(res?.data?.totalProject);
        // console.log('====',res?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    getProject();
  }, []);


  useEffect(() => {
    setCreateNew({
      projectId:data?.projectId||"",
      date:(data?.date !="" && NuDate({ value:data?.date, format: "YYYY-MM-DD" }) )||"",
      submittedOn:(data?.submittedOn !="" && NuDate({ value:data?.submittedOn, format: "YYYY-MM-DD" }) )||"",
      amount:data?.amount|| "",
      receivedAmount:data?.receivedAmount|| "",
      status:data?.status|| "",
      description:data?.description|| "",
      comments:data?.comments||"",
      invoice_no:data?.invoice_no||"",
      type:data?.type||"",
    })
  },[data])

  return (
    <div className="w-full mx-auto py-2 px-4 ">
      {contextHolder}
      <div className="md:flex justify-between w-full">
        <BreadCrumb
          items={[
            {
              title: (
                <Link to="/dashboard">
                  <Dasboard color="gray" width={10} height={10} />{" "}
                </Link>
              ),
            },
            {
              title: (
                <Link to="/payments/invoice-in">
                  <p className=" text-[12px] ">Finance</p>
                </Link>
              ),
            },
            {
              title: (
                <Link to="/payments/invoice-out">
                  <p className=" text-[12px] ">Outgoing</p>
                </Link>
              ),
            },
            { title: <p className=" text-[12px] ">Create</p> },
          ]}
        />

        <div className=" flex gap-2 items-center mr-6">
          <BackButton />
        </div>
      </div>
      <div>
        <div
          className=" w-full mx-auto h-[85%] rounded-[6px] mt-2"
          style={{ border: "1px solid #C5C5C5" }}
        >
          <form onSubmit={formik.handleSubmit}>
            <div className=" w-full flex justify-between items-center">
              <NuLabel label="My Diary" />
              {/* <BackButton /> */}
            </div>
            <div className="flex flex-wrap justify-start">
              <NuSelect
                label="Project"
                options={projectList || []}
                formik={formik}
                placeholder="Choose"
                name="projectId"
                width="w-full md:w-1/3"
                isRequired={true}
              />
              <NuInputText
                 label="Invoice No"
                 formik={formik}
                 placeholder="Invoice No"
                 name="invoice_no"
                 width="w-full md:w-1/3"
                 isRequired={true}
                />
              <NuInputNumber
                label="Amount"
                formik={formik}
                placeholder="Amount"
                name="amount"
                width="w-full md:w-1/3"
                isRequired={true}
              />

              <NuInputNumber
                label="Paid Amount"
                formik={formik}
                placeholder="Paid Amount"
                name="receivedAmount"
                width="w-full md:w-1/3"
                isRequired={true}
              />
                <NuInputText
                 label="Description"
                 formik={formik}
                 placeholder="Description"
                 name="description"
                 width="w-full md:w-1/3"
                 isRequired={true}
                />
              <NuDatePicker
                label="Due Date"
                formik={formik}
                name="date"
                width=" w-full md:w-1/3"
              />

              <NuDatePicker
                label="Submitted On"
                formik={formik}
                name="submittedOn"
                width=" w-full md:w-1/3"
              />
              <NuSelect
                label="Status"
                options={Status}
                formik={formik}
                placeholder="Choose"
                name="status"
                width="w-full md:w-1/3"
                isRequired={true}
              />

              <NuTextArea
                label="Comments"
                placeholder="Comments"
                formik={formik}
                name="comments"
                width="w-full md:w-2/3"
              />
            </div>

            <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
              <CancelButton handleClick={() => navigate(-1)} />
              <SubmitButton isLoading={isLoading} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
